var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.848,
    height: 16.755,
    viewBox: "0 0 22.848 16.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1w",
    transform: "translate(-16.43 -48.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15679",
    "data-name": "Path 15679",
    d: "M35.818,48.17h-16a.761.761,0,0,0,0,1.522h16a1.94,1.94,0,0,1,1.937,1.939v9.834A1.939,1.939,0,0,1,35.818,63.4H19.89a1.939,1.939,0,0,1-1.937-1.937v-9.91a.762.762,0,1,0-1.523,0v9.91a3.463,3.463,0,0,0,3.46,3.46H35.818a3.463,3.463,0,0,0,3.46-3.46V51.631a3.463,3.463,0,0,0-3.46-3.461ZM20.237,61.117h7.616a.762.762,0,0,0,0-1.523H20.237a.762.762,0,0,0,0,1.523Zm0-7.616h7.616a.762.762,0,0,0,0-1.523H20.237a.762.762,0,0,0,0,1.523Zm0,3.807h7.616a.762.762,0,0,0,0-1.523H20.237a.762.762,0,0,0,0,1.523Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_9054918_bx_rupee_icon",
    "data-name": "9054918_bx_rupee_icon",
    d: "M11.419,4.985V4H6v.985H7.724a1.474,1.474,0,0,1,1.387.985H6v.985H9.111a1.475,1.475,0,0,1-1.387.985H6V9.13l2.752,2.752h1.393L7.189,8.926h.535a2.466,2.466,0,0,0,2.413-1.97h1.282V5.97H10.137a2.43,2.43,0,0,0-.455-.985Z",
    transform: "translate(25.024 48.607)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.3466948e8da06a25398e3ff968e77b23.svg";
export { ForwardRef as ReactComponent };